<script>

  import BaseInput from "@/public/pages/integration-settings/components/Input/index.vue";
  import BaseButton from "@/public/components/common/uiKit/button/base/index.vue";
  import {mapActions, mapMutations, mapState} from "vuex";
  import InfoButton from "@/public/components/common/uiKit/info-button/index.vue";
  import DeleteButton from "@/public/components/common/uiKit/delete-button/index.vue";

  export default {
    name: "OrganizationNewRoles",
    components: {DeleteButton, InfoButton, BaseButton, BaseInput},
    methods: {
      ...mapMutations('organizations', [
        'switchTab',
        'changeDetailRole',
        'setDetailRoleId',
        'setChangeRoleStatus'
      ]),
      ...mapActions('organizations', [
        'getOrganizationUsers',
        'getOrganizationRole',
        'deleteOrganizationRole',
        'getOrganizationRoles',
      ]),
      ...mapActions('app', ['openModal']),
      handleAddRole() {
        this.switchTab(2)
        this.changeDetailRole(false)
        this.getOrganizationRoles()
      },

      deleteRole(currentRole) {
        this.$store.commit('organizations/setDetailRoleId', currentRole.id);
        this.openModal({
          name: 'RemoveRoleModal',
          payload: currentRole.name,
        });
      },

      changeRole(currentRole) {
        this.switchTab(2)
        this.changeDetailRole(true);
        this.setDetailRoleId(currentRole.id)
        this.setChangeRoleStatus(true)
        this.getOrganizationRole();
      },
    },
    computed: {
      ...mapState('organizations', [
        'organizationData',
      ]),
      list () {
        if (!this.organizationData.organizationRoles.length) return []
        return this.organizationData.organizationRoles.slice(0, 5)
      }
    }
  }
</script>

<template>
<div class="organization-information">
  <div class="header">
    <div class="header__left">
      <div class="header__title">
        {{ $t('organization.organization-new-roles') }}
      </div>
    </div>
  </div>
  <div class="list">
    <div class="header">
      <div class="col">{{ $t('organization.list.role') }}</div>
    </div>
    <template v-if="list.length">
      <div v-for="item in list" class="item">
        <div class="item__value">{{ item.name }}</div>
        <div class="item__actions">
          <info-button @click="changeRole(item)" />
          <delete-button @click="deleteRole(item)"/>
        </div>
      </div>
    </template>
    <p class="empty" v-else> {{ $t('organization.no-roles') }} </p>

  </div>
  <div class="more-btn">
    <base-button @click="handleAddRole" :label="list.length ? $t('organization.more') : $t('organization.organization_btn_add_role')" />
  </div>
</div>
</template>

<style scoped lang="scss">
.organization-information {
  border-radius: 20px;
  background: var(--bg-background-secondary, #202020);
  padding: 30px;
  font-family: $Gilroy;
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    &__title {
      color: var(--text-text-primary, #FFF);
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    &__left {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    &__right {
      display: grid;
      grid-template-columns: 48px 1fr;
      gap: 10px;
    }
    &__clear {
      border-radius: 10px;
      border: 1px solid var(--button-border-button-primary-default, #6750A4);
      width: 48px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__button {
      width: 180px;
    }
  }
  .list {
    margin-bottom: 30px;
    .empty {
      color: var(--text-color-text-secondary, #7E7E7E);
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin-top: 30px;
    }
    .header {
      border-radius: 10px;
      background: var(--bg-background-table, #333);
      padding: 0 20px;
      height: 56px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 0;
      .col {
        color: var(--text-color-text-secondary, #7E7E7E);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: center;
        gap: 5px;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
    .item {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      border-bottom:   1px solid var(--border-devider-primary, #353537);
      padding: 10px 20px 10px 20px;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        border-bottom: none;
      }
      &__value {
        color: var(--text-text-primary, #FFF);
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
      }
      &__actions {
        display: grid;
        grid-template-columns: 48px 48px;
        gap: 10px;
        justify-content: end;
        &-btn {
          cursor: pointer;
          height: 48px;
          width: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          border: 1px solid var(--button-border-button-primary-default, #6750A4);
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .organization-information {
    padding: 0;
    //.header {
    //  display: none;
    //}
    .header {
      padding: 20px 0 15px 20px;
      margin-bottom: 0;
      border-bottom: 1px solid var(--border-devider-primary, #353537);;
    }
    .header__left {
      .header__title {
        font-size: 16px;
      }
    }
    .list {
      .header {
        display: none;
      }
      .item {
        padding-top: 20px;
        &:first-child {
          padding-top: 20px;
        }
      }
      //.item {
      //  padding: 16px 20px 20px 20px;
      //  height: unset;
      //  grid-template-columns: 1fr;
      //  border-bottom: 1px solid var(--border-devider-primary, #353537);
      //  &:last-child {
      //    border-bottom: 0;
      //  }
      //  &__value {
      //    color: var(--text-color-text-secondary, #7E7E7E);
      //    font-size: 13px;
      //    &:first-child {
      //      color: var(--text-text-primary, #FFF);
      //    }
      //    &:nth-child(even) {
      //      display: flex;
      //      justify-content: flex-end;
      //    }
      //  }
      //  &__values {
      //    grid-template-columns: 1fr 1fr;
      //  }
      //  &__actions {
      //    margin-top: 20px;
      //    grid-template-columns: 1fr 48px 48px;
      //    &-btn {
      //      gap: 8px;
      //      &.history {
      //        width: unset;
      //        color: var(--bg-background-primary-purple, #6750A4);
      //        text-align: right;
      //        font-size: 13px;
      //        font-weight: 500;
      //        line-height: 28px;
      //        span {
      //          display: inline-block;
      //        }
      //      }
      //    }
      //  }
      //}
    }
    .more-btn {
      margin-top: 30px;
      padding: 0 20px 20px 20px;
    }

  }
}
</style>
